
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 14 14"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.116 9.21l1.2 3.68a.357.357 0 00.645.072l.669-1.075 1.72 1.744a.454.454 0 00.645 0 .434.434 0 000-.645l-1.72-1.744 1.075-.669a.368.368 0 00-.1-.645L7.57 8.757a.366.366 0 00-.454.453z","fill-rule":"evenodd"}}),_c('path',{attrs:{"d":"M10.47.117a1.268 1.268 0 011.266 1.267v6.582a.422.422 0 11-.844 0V1.384a.423.423 0 00-.422-.422H2.02a.422.422 0 00-.422.422v10.805a.423.423 0 00.422.422h4.223a.422.422 0 110 .845H2.02a1.268 1.268 0 01-1.267-1.267V1.384A1.268 1.268 0 012.02.117z"}}),_c('path',{attrs:{"d":"M2.774 3.693a.438.438 0 01.438-.437h2.624a.437.437 0 010 .874H3.213a.437.437 0 01-.438-.436zM8.023 5.438a.438.438 0 01-.437.438H3.213a.437.437 0 010-.874h4.373a.437.437 0 01.438.437zM8.01 7.187a.437.437 0 01-.437.438H3.212a.437.437 0 010-.874h4.36a.437.437 0 01.438.436z"}})])
          )
        }
      }
    